import axios from "axios";
import Cookies from "js-cookie";

const settingType = 'PROD';

// defaults
let backendBaseURL = 'https://react-backend.arpariapis.com'
let arpariEnv = 'PROD'
switch(settingType) {
  case 'PROD':
    backendBaseURL = 'https://react-backend.arpariapis.com'
    arpariEnv = 'PROD'
    break
  case 'PREPROD':
    backendBaseURL = 'http://localhost:8000'
    arpariEnv = 'PROD'
    break
  case 'DEV':
    backendBaseURL = 'http://localhost:8000'
    arpariEnv = 'TEST'
    break
  default:
    backendBaseURL = 'https://react-backend.arpariapis.com'
    arpariEnv = 'PROD'
    break
}
export const ARPARI_ENV = arpariEnv;

export const createUrl = (path) => {
  return `${backendBaseURL}${path}`
}

const headers = {
  // Pen test security findings
  'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
  'X-XSS-Protection': '1; mode=block',
  'Content-Security-Policy': `default-src 'self' ${backendBaseURL}`,
  'X-Frame-Options': 'SAMEORIGIN',
  'X-Content-Type-Options': 'nosniff',
  'Referrer-Policy': 'strict-origin-when-cross-origin',
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0',

  // just for local?
  // 'ngrok-skip-browser-warning': true,

  // hack for dthorne@dermody.com
  'psg-auth-token': Cookies.get("psg_auth_token")
};
const axiosInstance = axios.create({
  baseURL: backendBaseURL,
  headers: headers,
  withCredentials: true,
});

export const createAxiosInstance = (options = {}) => {
  let additionalHeaders = options['additionalHeaders'] || {}
  const controller = new AbortController();
  const myAxiosInstance = axios.create({
    signal: controller.signal,
    baseURL: backendBaseURL,
    headers: {
      ...headers,
      ...additionalHeaders,
      ...{ 'X-CSRFToken': Cookies.get('csrftoken') }
    },
    withCredentials: true,
    xsrfHeaderName: 'X-CSRFToken',
    xsrfCookieName: 'csrftoken',
  });

  const customAxiosInstance = {
    controller,
    instance: myAxiosInstance,
  };
  return customAxiosInstance;
};

export default axiosInstance;
